module.exports = __webpack_public_path__ + "static/we-do-fr-6e15443db107c5fdbf13ec1af63834e1.gif";